var map = {
	"./legal/CustomerReview": [
		35410,
		1192,
		5786,
		5454,
		2092,
		1263,
		7027,
		9615,
		8617
	],
	"./legalreviewTailwindUI/CustomerReview": [
		57430,
		1192,
		5786,
		5454,
		2092,
		1263,
		7430
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87285;
module.exports = webpackAsyncContext;